import { createAction } from '@reduxjs/toolkit'
import { NotificationItem } from '../../types/data'

export const setNotifications = createAction<NotificationItem[]>('notification/setNotifications')
